import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/programming-language-julia.svg?component
var programming_language_julia_exports = /* @__PURE__ */ __exportAll({
	default: () => programming_language_julia_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 128 128"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
		createElementVNode("circle", {
			cx: "64",
			cy: "36.57",
			r: "27.43"
		}, null, -1),
		createElementVNode("circle", {
			cx: "32.32",
			cy: "91.43",
			r: "27.43"
		}, null, -1),
		createElementVNode("circle", {
			cx: "95.68",
			cy: "91.43",
			r: "27.43"
		}, null, -1)
	])]);
}
var programming_language_julia_default = { render: render$1 };
//#endregion
export { programming_language_julia_default as default, programming_language_julia_exports, render$1 as render };

//# sourceMappingURL=programming-language-julia.svg.virtual.js.map